import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../../config/payrollApiConfig';
import {CreateEsicConfigurationPayload,UpdateEsicConfigurationPayload,} from './configurationTypes';

// Create
export const createEsicConfiguration = createAsyncThunk(
  'esicConfiguration/create',
  async (data: CreateEsicConfigurationPayload, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.post('/esic-config', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create ESIC configuration');
    }
  }
);

// Fetch All
export const fetchEsicConfigurationList = createAsyncThunk(
  'esicConfiguration/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get('/esic-config');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch ESIC configurations');
    }
  }
);

// Fetch By ID
export const fetchEsicConfigurationById = createAsyncThunk(
  'esicConfiguration/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/esic-config/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch ESIC configuration');
    }
  }
);

// Update
export const updateEsicConfiguration = createAsyncThunk(
  'esicConfiguration/update',
  async ({ id, ...data }: UpdateEsicConfigurationPayload & { id: number }, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.put(`/esic-config/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update ESIC configuration');
    }
  }
);

// Delete
export const deleteEsicConfiguration = createAsyncThunk(
  'esicConfiguration/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.delete(`/esic-config/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete ESIC configuration');
    }
  }
);
